import Uuid from 'uuid/v4'
import Vue from 'vue'
import { updateField } from 'vuex-map-fields'

import { initialItemData } from './constants'

export const MERGE_IMPORTED_ITEMS = 'MERGE_IMPORTED_ITEMS'
export const SET_GENERATED_ITEM = 'SET_GENERATED_ITEM'
export const REMOVE_GENERATED_ITEM = 'REMOVE_GENERATED_ITEM'
export const REMOVE_GENERATED_ITEMS = 'REMOVE_GENERATED_ITEMS'
export const RESET_ITEM_DATA = 'RESET_ITEM_DATA'
export const SET_CALCULATING_ZOOM = 'SET_CALCULATING_ZOOM'
export const SET_ITEM_FILE = 'SET_ITEM_FILE'
export const SET_ITEM_DATA = 'SET_ITEM_DATA'

function setItemData (state, data) {
  Vue.set(state, 'item', { ...data })
}

export default {
  [SET_CALCULATING_ZOOM] (state, isCalculatingZoom) {
    state.isCalculatingZoom = isCalculatingZoom
  },
  [MERGE_IMPORTED_ITEMS] (state, importedItems) {
    state.generatedItems = {
      ...state.generatedItems,
      ...importedItems
    }
  },
  async [REMOVE_GENERATED_ITEM] (state, uuid) {
    // eslint-disable-next-line no-undef
    const shouldRemove = await swal({
      title: 'Deseja destruir este artefato?',
      text: 'Todos seus componentes serão perdidos para sempre!',
      icon: 'warning',
      dangerMode: true,
      buttons: ['Cancelar', 'Descartar artefato']
    })

    if (shouldRemove) {
      Vue.delete(state.generatedItems, uuid)
    }
  },
  async [REMOVE_GENERATED_ITEMS] (state) {
    // eslint-disable-next-line no-undef
    const shouldRemove = await swal({
      title: 'Deseja destruir todos os artefatos?',
      text: 'Isso pode abalar o equilibrio mágico da região!',
      icon: 'warning',
      dangerMode: true,
      buttons: ['Cancelar', 'Destruir artefatos']
    })

    if (shouldRemove) {
      state.generatedItems = {}
    }
  },
  [RESET_ITEM_DATA] (state) {
    setItemData(state, initialItemData);
  },
  [SET_GENERATED_ITEM] (state, image) {
    const uuid = state.item.uuid || Uuid();

    Vue.set(state.generatedItems, uuid, {
      ...state.item,
      uuid,
      image
    })
  },
  [SET_ITEM_DATA] (state, data) {
    setItemData(state, data)
  },
  [SET_ITEM_FILE] (state, file) {
    Vue.set(state.item, 'file', file)
  },
  updateField (state, payload) {
    clearTimeout(state.timeoutId)

    state.timeoutId = setTimeout(() => updateField(state, payload), 100)
  },
}